module.exports = __webpack_public_path__ + "assets/img/select_products2.e07e8a08.svg";